export default __webpack_public_path__ + "static/media/RPAZ_S1_FG_Still00003_C.29e408ca.JPG";